import React, { memo, PropsWithChildren, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsEmbedded } from './selectors/device'
import { useNavigate } from 'react-router-dom'
import LayoutManager from './util/layoutManager'
import ChartManager from './util/chartManager'
import StrategyChartManager from './util/strategyChartManager'
import MultistrikeChartManager from './util/multistrikeChartManager'
import EmbeddedDataManager from './util/embeddedDataManager'
import { isEmbeddedModeSet } from './util/general'
import commonActions from './actions/common.actions'
import TradeManager from './util/TradeManger'
import PayoffManager from './util/payoffManager.ts'
import AlertsManager from './util/alertsManager.ts'

if (isEmbeddedModeSet()) {
    window.layoutManager = new LayoutManager()
    window.chartManager = new ChartManager()
    window.strategyChartManager = new StrategyChartManager()
    window.multistrikeChartManager = new MultistrikeChartManager()
    window.embeddedDataManager = new EmbeddedDataManager()
    window.tradeManager = new TradeManager()
    window.payoffManager = new PayoffManager()
    window.alertsManager = new AlertsManager()
}

const EmbeddedWrapper: React.FC<PropsWithChildren> = ({ children }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const isEmbedded = useSelector(selectIsEmbedded)

    useEffect(() => {
        if (isEmbedded) {
            if (!window.navigate) {
                window.navigate = navigate
            }

            if (!window.setTheme) {
                window.setTheme = (theme: any) => {
                    commonActions.setThemeMode(dispatch, theme as any)
                }
            }
        }
        return () => {
            window.navigate = undefined
        }
    }, [isEmbedded, navigate])

    useEffect(() => {
        if (isEmbedded) {
            document.body.classList.add('embedded')
            const meta = document.querySelector('meta[name="viewport"]')
            if (meta) {
                meta.setAttribute(
                    'content',
                    'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
                )
            }
        }
        return () => {
            document.body.classList.remove('embedded')
        }
    }, [isEmbedded])
    return children
}

export default memo(EmbeddedWrapper)
